import { DeleteOutlined, EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Input, Pagination } from "antd";
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import viVN from 'antd/locale/vi_VN';
import { CustomLoadingOverlayTable, dataPagination, getWidthFromHeader, renderValueAsJSX } from "../../../../until";
import { Dashboard } from "../../../../components/ExportImgFigma";
import ".././stylestabs.scss";
import { ICustomer, IVehicleInterestContactHistory, ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import FilterHeader from "./Components/FilterHeader";
import SettingFeilds from "./Components/SettingFeilds";
import { formatNumber } from "../../../../services/mixin";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { generateColumnsFromCodesAgGridReactRecordCar } from "./ContactInformation";
import { NodataTable } from "../../../../components/NoDataTable";
import { NO_DATA } from "../../../../env";
import { NO_VIEW } from "../../../../services/data";

const { RangePicker } = DatePicker;


export type ContactHistoryHandle = {
  getFilters: () => {
    dataFilterActive: FlattenedField[]; dataFilterNoActive: ListField[];
  };
  setFilters: (active: FlattenedField[], noActive: ListField[]) => void; // 👈 thêm hàm này
};

interface Prop {
  loadingTableDetail: boolean
  dataFieldsActive: FlattenedField[]
  data?: IVehicleInterestContactHistory

  pagination: IPagination

  onPaginationChange: (page: number, pageSize: number) => void
}

const ContactHistory = forwardRef<ContactHistoryHandle, Prop>(
  (
    { loadingTableDetail, dataFieldsActive, data, pagination,
      onPaginationChange
    }, ref
  ) => {

    // useImperativeHandle(ref, () => ({
    //   getFilters: () => ({
    //     dataFilterActive,
    //     dataFilterNoActive,
    //   }),
    //   setFilters: (dataFilterActive, dataFilterNoActive) => {
    //     setDataFilterActive(dataFilterActive);
    //     setDataFilterNoActive(dataFilterNoActive);
    //   },
    // }));

    const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

    //#region Cấu hình bảng
    const memoizedColumnDefs = useMemo(() => {
      return generateColumnsFromCodesAgGridReactRecordCar(
        columnsMapShow, dataFieldsActive, undefined,
        () => { }
      );
    }, [columnsMapShow, dataFieldsActive]);




    const tableData = useMemo(() => {
      return data?.data?.map((item) => {
        const fieldValues = item.fields.reduce<Record<string, any>>((acc, field) => {
          acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;

          if (field.additionalData) {
            acc[`${field.fieldCode}__meta`] = field.additionalData;
          }

          return acc;
        }, {});

        return {
          ...item,
          key: item.id.toString(),
          ...fieldValues,
        };
      }) ?? [];
    }, [data?.data]);

    useEffect(() => {
      const codes = dataFieldsActive?.map((f) => f.fieldCode);
      setColumnsMapShow(codes);
    }, [dataFieldsActive]);
    //#endregion

    return (
      <>
        {/* <div className="flex gap-3 mb-3">
          <div className="custom-page-css w-1-3 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
            <Input
              placeholder="Tìm kiếm theo thông tin lịch sử tiếp xúc"
              className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={dataFilter?.search}
            onChange={(e) => setDataFilter({ ...dataFilter, search: e.target.value })}
            />
            <div className=" border-l-F2F4F7 h-full d-flex align-center">
              <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
            </div>
          </div>
          <div className="custom-range-picker-input">
            <RangePicker
              popupClassName="t-ctrl-date-picker"
              placeholder={["Từ ngày", "Đến ngày"]}
              format="DD/MM/YYYY"
              allowClear
            onCalendarChange={onDateChange}
            />
          </div>
        </div> */}
        <div className="custom-page-css w-full flex gap-3 mb-3">
          <div className="custom-page-css  flex  flex-column rounded border"
            style={{
              width: '50%'
            }}
          >
            <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
                <img
                  src={Dashboard}
                  alt=""
                  style={{ height: 16, width: 16, objectFit: "contain" }}
                />
              </div>
              <span className="custom-page-css text-xl font-light  text-000000">
                Tổng quan
              </span>
            </div>
            <div className="custom-page-css flex py-2">
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                <span className="custom-page-css text-2xl font-light font-medium px-1  text-000000">
                  {formatNumber(data?.summary?.totalInteractionCount ?? 0)}
                </span>
                <span className="custom-page-css text-xl font-light  text-000000">
                  Số lần tiếp xúc
                </span>
              </div>
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                <span className="custom-page-css text-2xl font-light font-medium px-1  text-000000">
                  {data?.summary?.latestInteractionDate ?? NO_DATA}
                </span>
                <span className="custom-page-css text-xl font-light  text-000000">
                  Ngày tiếp xúc gần nhất
                </span>
              </div>
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
                <span className="custom-page-css text-2xl font-light font-medium px-1  text-000000">
                  {data?.summary?.customerLastAssessment ?? NO_DATA}
                </span>
                <span className="custom-page-css text-xl font-light  text-000000">
                  Trạng thái KH gần nhất
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="ag-theme-alpine custom-table-ag custom-page-css" style={{ width: "100%" }}>
          <AgGridReact
            rowData={tableData}
            columnDefs={memoizedColumnDefs}
            overlayNoRowsTemplate={NodataTable}

            loading={loadingTableDetail}
            loadingOverlayComponent={CustomLoadingOverlayTable}
            rowHeight={55}
            domLayout="autoHeight"
            className="my-auto-height-grid w-100"

            onGridReady={(params) => {
              params.api.sizeColumnsToFit();
            }}
          />
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() =>
                  `Tổng cộng ${dataPagination(
                    pagination.total,
                    pagination.pageSize,
                    pagination.current
                  ).totalPage} trang`
                }
                className="rs-pagination"
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </>
    );
  })
export default ContactHistory;
